import { ManagerSelectCustom } from "../../users/ManagerSelectCustom";
import SalaryInput from "../../users/SalaryInput";
import { CheckTreePickerAllOption } from "./CheckTreePickerAllOption";
import { CreateLambdaComplement } from "./CreateLambdaComplement";
import { CreateTablesComplement } from "./CreateTablesComplement";
import { SelectCustom } from "./SelectCustom";
import { CheckTreePickerUserRestrict } from "./user/CheckTreePickerUserRestrict";
import ResetPasswordUser from "./resetPasswordUser/ResetPasswordUser";

//Clients
import UserCustomEmailInput from "./user/UserCustomEmailInput";

export default {
  CheckTreePickerAllOption,
  CheckTreePickerUserRestrict,
  CreateLambdaComplement,
  CreateTablesComplement,
  ManagerSelectCustom,
  ResetPasswordUser,
  UserCustomEmailInput,
  SelectCustom,
};
